export default "__VITE_ASSET__498d3f72__"